const wait = (timeout: number): Promise<unknown> =>
  new Promise(resolve => {
    setTimeout(resolve, timeout)
  })

export default wait
